import React from "react";
import _ from "lodash";
import { FormControl } from "react-bootstrap";
import autoBind from "react-autobind";
class PlayerPickerSelect extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(event) {
		if (this.props.onChange) {
			this.props.onChange(event.target.value);
		}
	}

	render() {
	
		const { item, options, placeholder, disabled } = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const pickerTheme = _.get(theme, "item.picker.basic");

		let entries = [];

		entries.push(<option value="" key={"option-placeholder"} label={placeholder} />);

		_.each(options, (pickerItem, idx) => {
			entries.push(<option key={"option-" + pickerItem.value + "-" + idx} value={pickerItem.value}>{pickerItem.label}</option>);
		});

		return <FormControl disabled={disabled} style={pickerTheme} componentClass="select" value={item.value} onChange={this.onChange}>
			{entries}
		</FormControl>;
	}
}

export default PlayerPickerSelect;